export function setDeepValue(obj, path, value) {
  const keys = path.split(".");
  let temp = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    let key = keys[i];
    if (!temp[key]) {
      temp[key] = {};
    }
    temp = temp[key];
  }

  temp[keys[keys.length - 1]] = value;
}



// WEBPACK FOOTER //
// ./src/utils/index.js